import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import NewFooter from '../../../../src/components/HomePage/NewFooter';
import {
  base_date,
  convertToLocaleFormat,
  format_locale_date_ind,
  getClosestUpdateTimeInMin,
  getDifferenceDate,
  getIndexChangeArr,
  getTotalOrders,
  isInViewport,
} from '../../../Constants/B2G1CategoryPage';
import GlobalStyle from '../../../styles/globalStylesV2';
import { getScreenName, getUserIsLoggedIn } from '../../../Utils/helper';
import { isDesktopUser } from '../../../Utils/ProductUtils';
import VideoSection from '../../DiaperLandingPage/VideoSection';
import { DiaperWrapper } from '../../IVF/IVFCarousel/styled';
import { lactoFeatureData } from '../../Product/FertilityTrustSection/constant';
import PdpOfferNewDesign from '../../Product/OfferCarousel/PdpOfferNewDesign';
import { whatsappBanerData } from '../../Product/WidgetsMergeCover/constant';
import WhatsappBanner from '../../Product/WidgetsMergeCover/WhatsappBanner';
import WrapperFeatures from '../../ProductNew/ProductDetail/WrapperFeatures';
import CDPageLiveCount from '../../StoreCategoryPage/CDPageLiveCount';
import { FAQLactomama } from '../../StoreCategoryPage/TopBannerwithtext/constant';
import TopCarousel from '../../StoreHomePage/TopCarousel';
import UniversalAccordion from '../../StoreHomePage/UniversalAccordion';
import { AccordionHeading } from '../../StoreHomePage/UniversalAccordion/styled';
import BuyNowButton from '../BuyNowButton';
import {
  ImageOuter,
  LactomamaDetail,
  RatingContainer,
  RatingCount,
  RatingText,
  ReviewsLink,
  Separator,
  StarIcon,
} from '../DetailSection/styled';
import MarqueeStrip from '../MarqueeStrip';
import ProductSection from '../ProductSection';
import VideoGridSection from '../VideoGridSection';
import Image from 'next/image';
import LazyLoad from 'react-lazyload';
import FloatingVideo from '../../FloatingVideo/index';
import Modal from 'react-modal';
import { ModalCrossbtn } from '../../ProductNew/TrustStrip/styled';
import { scrollableBottomSheet } from '../../../Utils/redirections';
import PackBottomPopup from './PackBottomPopup';
import { images } from '../../../Constants/ImageUrls';
import Loader from '../../Loader';
import { useGetCartData } from '../../../datafetchers/CartWidget';
import {
  fireProductActionEvent,
  productActionClick,
} from '../../../Utils/productAction';
import { PowerContentContainer } from './styled';
import LactoMamaBeforeAfter from './LactoMamaBeforeAfter';
import SingleBanner from '../../Clinic/ClinicStore/SingleBanner';
import PDPHeadElements from '../../Product/PDPHeadElements/index';
import { DesktopAndMobileDivWrapper } from '../../../styles/globalStyles';
import { SnackBar } from '../../Product/PdpHeader/styled';
import { getWebUserType } from '../../../Utils/getWebUserType';
import { fireEvent } from '../../../Utils/fireEvent';
import { InclTaxNew } from '../../Product/ProductDetail/styled';
import PdpNddSddStrip from '../../ProductNew/SddNdd';
import {
  checkEligibilityForSsoTooltip,
  getNewAndRepeatUser,
} from '../../../Utils/commonUtils';
import CategoryHeadElement from '../../StoreCategoryPage/CategoryHeadElement';
import KwikPassSsoTooltip from '../../KwikPassSsoTooltip';
import HealthBundle from '../../Product/HealthBundle/HealthBundle';

const SizeAndPacksCover = dynamic(
  () => import('../../Product/SizeAndPacksCover'),
);
const NewHeader = dynamic(() => import('../../HomePage/NewHeader'), {
  ssr: false,
});
const RatingReviews = dynamic(() => import('../../Product/RatingandReviews'), {
  ssr: false,
});

function LactoMamaPageOuter(props) {
  const {
    categoryData,
    generalItemsData,
    generalItemsDataByFlavour,
    flavourTitles,
    productData,
    offerData,
    showNewLactoPage,
    productPriceData,
    ReviewJSONLDData,
    DiscussionJSONLDData,
    variantDataForPopup,
    sddNddData,
    setGeneralItems,
    setTabThemeColor,
    tabThemeColor,
    tabThemeSecondaryColor,
    setTabThemeSecondaryColor,
  } = props;
  const [openPackPopup, setOpenPackPopup] = useState(false);
  const [isDesktop, setDesktop] = useState(false);

  const router = useRouter();
  const [categoryNavBarTop, setCategoryNavBarTop] = useState(56);
  const [changeCartCount, setChangeCartCount] = useState();
  const [pageLiveCountValue, setPageLiveCountValue] = useState(0);
  const [changedIndexes, setChangedIndexes] = useState([]);
  const [elementInViewport, setElementInViewport] = useState(false);
  const [showHeader, setShowHeader] = useState('-56px');
  const [isFixed, setIsFixed] = useState(false);
  const oldScrollValue = useRef(0);
  const throttleTimeout = useRef(false);
  const timerRef = useRef('');
  const selectDiaperRef = useRef();
  const stickyBuyNow = useRef();
  const [showToast, setshowToast] = useState(false);
  const [toastValue, setToastValue] = useState('');
  const [selectedVariant, setSelectedVariant] = useState(productData?.id);
  const [showSsoTooltipDot, setShowSsoTooltipDot] = useState(false);
  const [showSsoTooltip, setShowSsoTooltip] = useState(false);
  const [addProductToCartOnVariantClick, setAddProductToCartOnVariantClick] =
    useState(false);
  const [isFullScreenVideoEnabled, setIsFullScreenVideoEnabled] =
    useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [loginPopUp, setLoginPopUp] = useState(false);
  const [showFadeEffect, setShowFadeEffect] = useState(false);

  const floatingVideoData = generalItemsData.items.find(
    (item) => item.itemType == 'TYPE_REELS',
  );
  const DEFAULT_PRODUCT_ID = 3928;
  const [userSelectedVariant, setUserSelectedVariant] =
    useState(DEFAULT_PRODUCT_ID);
  const [showLoader, setshowLoader] = useState(false);
  const { data } = useGetCartData();

  const [userType, setUserType] = useState(null); // Start with null to avoid hydration mismatch
  const [isClient, setIsClient] = useState(false);

  const getProductGif = () => {
    switch (selectedVariant) {
      case 3878:
        return 'https://images.myloapp.in/NestJsUploads/animated_webp/1734403261050-PO1-Lactomama.webp';
      case 3928:
        return 'https://images.myloapp.in/NestJsUploads/animated_webp/1734403149294-PO2-Lactomama.webp';
      case 3929:
        return 'https://images.myloapp.in/NestJsUploads/animated_webp/1734403149292-PO4-Lactomama.webp';
      default:
        break;
    }
  };

  useEffect(() => {
    setIsClient(true);
    setUserType(getWebUserType());
  }, []);

  useEffect(() => {
    // if itemType: "BEFORE_AND_AFTER" not found in generalItemsData?.items then insert
    const itemTypeExists = generalItemsData?.items?.some(
      (item) => item.itemType === 'BEFORE_AND_AFTER',
    );
    if (!itemTypeExists && showNewLactoPage) {
      generalItemsData?.items?.splice(4, 0, {
        itemType: 'BEFORE_AND_AFTER',
        beforeAfterData: {
          beforeImage:
            'https://images.myloapp.in/NestJsUploads/1735908404385-Bottle-milk-comparison.webp',
          afterImage:
            'https://images.myloapp.in/NestJsUploads/1735908404385-Bottle-milk-comparison.webp',
          heading: 'Clinical Results of Mylo Care Stretch Marks Cream',
          description:
            'Study done by an NABL Accredited Lab on 100 Post Delivery Woman Over 84 Days',
          footer: 'Stretch mark perimeter reduction results',
          defaultValue: 28,
        },
      });
    }
  }, [generalItemsData]);

  const renderLactomamaDetail = () => (
    <LactomamaDetail>
      <div className="background">
        <h2 className="head">
          Make Breastfeeding <br />
          <span> Easy & Joyful</span>
        </h2>
        <ImageOuter>
          <div className="imageOuter">
            <Image
              src={getProductGif()}
              alt={'Make Breastfeeding Easy & Joyful'}
              className="image"
              sizes="33vw"
              layout="fill"
              quality={90}
              loading="lazy"
            />
          </div>
        </ImageOuter>
      </div>
    </LactomamaDetail>
  );

  const updateLiveCount = () => {
    setPageLiveCountValue((prev) => prev + 1);
    let num1 = convertToLocaleFormat(
      pageLiveCountValue,
      format_locale_date_ind,
    ).split('');
    let num2 = convertToLocaleFormat(
      pageLiveCountValue + 1,
      format_locale_date_ind,
    ).split('');

    let index_change = getIndexChangeArr(num1, num2);
    setChangedIndexes(index_change);
    setTimeout(() => {
      setChangedIndexes([]);
    }, [2000]);
  };

  useEffect(() => {
    if (elementInViewport) updateLiveCount();
  }, [elementInViewport]);

  useEffect(() => {
    if (pageLiveCountValue) {
      clearTimeout(timerRef.current);
      const timer = getClosestUpdateTimeInMin() * 60 * 1000;
      timerRef.current = setTimeout(updateLiveCount, [timer]);
    }
  }, [pageLiveCountValue]);

  useEffect(() => {
    const isDesktop = isDesktopUser();
    setDesktop(isDesktop);
    // if (isDesktop)
    //     router.replace(
    //         "/product/mylo-lactomama-granules---boost-breast-milk-supply---300gm-3878" +
    //         window.location.search,
    //     );
    if (isDesktop) {
      setShowHeader('0px');
    }
    oldScrollValue.current = window.pageYOffset;

    function scrollUpOrDown() {
      if (!throttleTimeout.current && !isDesktop) {
        setTimeout(() => {
          let newValue = window.pageYOffset;
          if (oldScrollValue.current < newValue) {
            setCategoryNavBarTop(-19); //for Desktop screen
            if (newValue > 56) {
              setShowHeader('-56px'); // for Mweb
            }

            //on scroll down
          } else if (oldScrollValue.current > newValue) {
            setCategoryNavBarTop(56); // for Desktop screen
            setShowHeader('0px'); // for Mweb

            // on scroll up
          }
          oldScrollValue.current = newValue;
          throttleTimeout.current = false;
        }, 100);
      }
      throttleTimeout.current = true;
      const isInViewPort = isInViewport(selectDiaperRef.current);
      if (isInViewPort === true) setElementInViewport(isInViewPort);
    }

    window.addEventListener('scroll', scrollUpOrDown);

    const current_date = new Date();
    const { days, minutes } = getDifferenceDate(current_date, base_date);
    const total_orders = getTotalOrders(days, minutes);

    setPageLiveCountValue(total_orders);
    const target = stickyBuyNow.current;
    const handleScroll = () => {
      if (target && isInViewport(target)) {
        setIsFixed(false);
      } else {
        setIsFixed(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    // Initial check
    handleScroll();
    fireEvent({
      category: 'viewed_landing_page',
      screen_name: getScreenName(),
      parent: getNewAndRepeatUser(),
    });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
      window.removeEventListener('scroll', scrollUpOrDown);
    };
  }, []);

  const handleClose = () => {
    fireEvent({
      category: 'discard_popup',
      parent: 'diaper cart filler',
      screen_name: getScreenName(),
    });
    setOpenPackPopup(false);
    document.getElementsByTagName('body')[0].classList.remove('noScroll');
  };

  const BottomStylePopup = scrollableBottomSheet('', '', '-100px', '', 'auto');

  const addToCart = async (productId, data) => {
    handleClose();
    const newProductData = productData?.variantData?.filter(
      (variant) => variant.id == productId,
    )[0];
    setSelectedVariant(productId);
    setUserSelectedVariant(productId);
    fireProductActionEvent('clicked_buy_now', newProductData);
    setshowLoader(true);

    if (data) {
      await mutate('/api/getNewCartAmountOfUserWeb', null, false);
    }
    const apiResponse = await productActionClick('cart', newProductData, 1);
    if (apiResponse == true) {
      setshowLoader(false);
    } else {
      setshowLoader(false);
    }
  };

  const openChooseLactoMamaPopup = () => {
    setOpenPackPopup(true);
  };

  const [isVideoVisible, setIsVideoVisible] = useState(false);
  const [showFullScreenVideo, setShowFullScreenVideo] = useState(false);
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVideoVisible(true);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (productData?.variantData?.length) {
      // debugger
      productData?.variantData?.forEach((variant) => {
        switch (variant.id) {
          case 3946:
            variant.variantFeature = [
              {
                feature: '1 Bottle (300g)',
                featureHi: '',
              },
            ];
            variant.ppuText = `₹${Math.floor((variant.price * 100) / 300)}`;
            variant.subText = 'Chocolate';
            variant.title = '15 Days Pack';
            break;
          case 3963:
            variant.variantFeature = [
              {
                feature: '1 Bottle (300g)',
                featureHi: '',
              },
            ];
            variant.ppuText = `₹${Math.floor((variant.price * 100) / 300)}`;
            variant.subText = 'Kesar Badam';
            variant.title = '15 Days Pack';
            break;
          case 3878:
            variant.variantFeature = [
              {
                feature: '1 Bottle (300g)',
                featureHi: '',
              },
            ];
            variant.ppuText = `₹${Math.floor((variant.price * 100) / 300)}`;
            variant.subText = 'Elaichi';
            variant.title = '15 Days Pack';
            break;
          case 4095:
            variant.variantFeature = [
              {
                feature: '2 Bottles (600g)',
                featureHi: '',
              },
            ];
            variant.ppuText = `₹${Math.floor((variant.price * 100) / 600)}`;
            variant.subText = 'Chocolate';
            variant.title = '30 Days Pack';
            break;
          case 4100:
            variant.variantFeature = [
              {
                feature: '2 Bottles (600g)',
                featureHi: '',
              },
            ];
            variant.ppuText = `₹${Math.floor((variant.price * 100) / 600)}`;
            variant.subText = 'Kesar Badam';
            variant.title = '30 Days Pack';
            break;
          case 3928:
            variant.variantFeature = [
              {
                feature: '2 Bottles (600g)',
                featureHi: '',
              },
            ];
            variant.ppuText = `₹${Math.floor((variant.price * 100) / 600)}`;
            variant.subText = 'Elaichi';
            variant.title = '30 Days Pack';
            break;
          case 4096:
            variant.variantFeature = [
              {
                feature: '4 Bottles (1.2kg)',
                featureHi: '',
              },
            ];
            variant.ppuText = `₹${Math.floor((variant.price * 100) / 1200)}`;
            variant.subText = 'Chocolate';
            variant.title = '60 Days Pack';
            break;
          case 3929:
            variant.variantFeature = [
              {
                feature: '4 Bottles (1.2kg)',
                featureHi: '',
              },
            ];
            variant.ppuText = `₹${Math.floor((variant.price * 100) / 1200)}`;
            variant.subText = 'Elaichi';
            variant.title = '60 Days Pack';
            break;
          case 4101:
            variant.variantFeature = [
              {
                feature: '4 Bottles (1.2kg)',
                featureHi: '',
              },
            ];
            variant.ppuText = `₹${Math.floor((variant.price * 100) / 1200)}`;
            variant.subText = 'Kesar Badam';
            variant.title = '60 Days Pack';
            break;
          default:
            break;
        }
      });
    }
  }, [productData?.variantData]);

  const eventHandler = (data) => {
    fireEvent({
      category: 'clicked_offer_on_pdp',
      support_variable: data.offer_heading ? data.offer_heading : data,
      parent: 'Copy Code',
      term_id: data?.term_id,
    });
    if (data == 'copyCode') {
      setToastValue('Copied successfully');
      setshowToast(true);
    } else if (data?.offer_heading) {
      setToastValue('Apply on checkout!');
      setshowToast(true);
    } else {
      setToastValue('');
      setshowToast(false);
    }
  };

  useEffect(() => {
    if (showToast) {
      setTimeout(() => {
        setshowToast(false);
      }, 2800);
    }
  }, [showToast]);

  const newVariantData = [];
  const variantSorting = [
    3929, 3928, 4095, 3878, 4096, 3946, 4097, 4098, 3963, 4100, 4101,
  ];
  for (const productId of variantSorting) {
    const obj = productData.variantData.find((obj) => obj.id === productId);
    if (obj) {
      newVariantData.push(obj);
    }
  }
  productData.variantData = newVariantData;

  const handleReviewsClick = useCallback(() => {
    // Add analytics
    fireEvent({
      category: 'clicked_reviews_link',
      screen_name: getScreenName(),
      parent: 'lactomama_product_page',
    });

    // Direct navigation - no timeout needed
    const productId = productData?.id || productData?._id;
    if (productId) {
      router.push(`/reviews/${productId}`);
    }
  }, [productData?.id, productData?._id, router]);

  // const handleReviewsClick = () => {
  //   // Add analytics if needed
  //   fireEvent({
  //     category: 'clicked_reviews_link',
  //     screen_name: getScreenName(),
  //     parent: 'lactomama_product_page',
  //   });

  //      // Scroll to reviews section with proper handling for layout shifts
  //   const scrollToReviews = () => {
  //     // const reviewsSection = document.getElementById('rating-reviews-section');
  //     // if (reviewsSection) {
  //     //   const headerOffset = isDesktop ? 60 : 80;
  //     //   const elementPosition = reviewsSection.getBoundingClientRect().top + window.pageYOffset;

  //     //   window.scrollTo({
  //     //     top: elementPosition - headerOffset,
  //     //     behavior: 'smooth'
  //     //   });
  //     // }
  //      router.push(`/reviews/${productData?.id || productData?._id}`);
  //   };

  // };

  const formatRatingCount = (num) => {
    if (!num && num !== 0) {
      return '0';
    }

    const numValue = typeof num === 'string' ? parseFloat(num) : num;

    if (isNaN(numValue)) {
      return '0';
    }

    // Always use toLocaleString for rating counts to show commas
    return numValue.toLocaleString();
  };

  // For review counts - show 'k' format for large numbers, commas for smaller
  const formatReviewCount = (num) => {
    if (!num && num !== 0) {
      return '0';
    }

    const numValue = typeof num === 'string' ? parseFloat(num) : num;

    if (isNaN(numValue)) {
      return '0';
    }

    if (numValue >= 1000) {
      return (numValue / 1000).toFixed(1).replace('.0', '') + 'k';
    }

    return numValue.toLocaleString();
  };

  const renderGeneralItem = (element, index) => {
    switch (element?.itemType) {
      case 'BEFORE_AND_AFTER':
        return (
          <>
            <LazyLoad
              height={100}
              once
              offset={100}
              key={element?.itemName + index}
            >
              <DesktopAndMobileDivWrapper>
                <PowerContentContainer>
                  <LactoMamaBeforeAfter
                    beforeAfterData={element?.beforeAfterData}
                    tabThemeColor={tabThemeColor}
                    tabThemeSecondaryColor={tabThemeSecondaryColor}
                  />
                </PowerContentContainer>
              </DesktopAndMobileDivWrapper>
            </LazyLoad>
          </>
        );
      case 'PDP_VARIANT_OPTIONS':
        return (
          <>
            {/* {isClient && userType === 'A' ? (
              <DesktopAndMobileDivWrapper>
                <div key={element?.itemName + index}>
                  <SizeAndPacksCover
                    productData={productData}
                    showNewLactomamaVariantUx={true}
                    setShowFadeEffect={setShowFadeEffect}
                    setUserSelectedVariant={setUserSelectedVariant}
                    setSelectedVariant={setSelectedVariant}
                    userSelectedVariant={userSelectedVariant}
                    setGeneralItems={setGeneralItems}
                    generalItemsDataByFlavour={generalItemsDataByFlavour}
                    flavourTitles={flavourTitles}
                    tabThemeColor={tabThemeColor}
                    setTabThemeColor={setTabThemeColor}
                    setTabThemeSecondaryColor={setTabThemeSecondaryColor}
                  />
                </div>
              </DesktopAndMobileDivWrapper>
            ) : (
              <DesktopAndMobileDivWrapper>
                <LactomamaDetail key={element?.itemName + index}>
                  <div className="healthWrapper">
                    <HealthBundle
                      lactoMamaCategory={true}
                      productId={userSelectedVariant}
                      data={productData.variantData.filter((variant) =>
                        [3878, 3928, 3929].includes(variant.id),
                      )}
                      setSelectedVariant={(variantSelection) => {
                        setSelectedVariant(variantSelection);
                        setUserSelectedVariant(variantSelection);
                      }}
                      variantPriceData={
                        productPriceData?.variantOption?.[0]?.data
                      }
                      setAddProductToCartOnVariantClick={
                        setAddProductToCartOnVariantClick
                      }
                    />
                  </div>
                </LactomamaDetail>
              </DesktopAndMobileDivWrapper>
            )} */}

            <DesktopAndMobileDivWrapper>
              <div key={element?.itemName + index}>
                <SizeAndPacksCover
                  productData={productData}
                  showNewLactomamaVariantUx={true}
                  setShowFadeEffect={setShowFadeEffect}
                  setUserSelectedVariant={setUserSelectedVariant}
                  setSelectedVariant={setSelectedVariant}
                  userSelectedVariant={userSelectedVariant}
                  setGeneralItems={setGeneralItems}
                  generalItemsDataByFlavour={generalItemsDataByFlavour}
                  flavourTitles={flavourTitles}
                  setTabThemeColor={setTabThemeColor}
                  setTabThemeSecondaryColor={setTabThemeSecondaryColor}
                  tabThemeColor={tabThemeColor}
                />
              </div>
            </DesktopAndMobileDivWrapper>

            <InclTaxNew style={{ margin: '5px 0px 10px 15px' }}>
              M.R.P. (incl of all taxes)
            </InclTaxNew>
            <div ref={stickyBuyNow}></div>

            <BuyNowButton
              userType={userType}
              isFixed={isFixed}
              selectedVariant={selectedVariant}
              newProductData={productData?.variantOption?.[0]?.data?.find(
                (variant) => variant.product_id === userSelectedVariant,
              )}
              lactoMama={true}
              userSelectedVariant={userSelectedVariant}
              openChooseLactoMamaPopup={openChooseLactoMamaPopup}
              addProductToCartOnVariantClick={addProductToCartOnVariantClick}
              setAddProductToCartOnVariantClick={
                setAddProductToCartOnVariantClick
              }
              offerData={offerData}
              variantData={productData?.variantData}
            />
          </>
        );
      case 'WEB_PRODUCT_FEATURES_SLOT':
        return (
          <>
            <DesktopAndMobileDivWrapper>
              <LactomamaDetail
                key={element?.itemName + index}
                tabThemeColor={tabThemeColor}
              >
                <h1 className="head">
                  LactoMama™ <br />
                  <span>Lactation Granules</span>
                </h1>
              </LactomamaDetail>

              <RatingContainer>
                <StarIcon>★</StarIcon>
                <RatingText>{productData?.avg_rating}</RatingText>
                <RatingCount onClick={handleReviewsClick}>
                  ({formatRatingCount(productData?.rating_count)} Ratings)
                </RatingCount>
                <ReviewsLink onClick={handleReviewsClick}>
                  {formatReviewCount(productData?.review_count)} Reviews
                </ReviewsLink>
              </RatingContainer>

              <WrapperFeatures featureData={lactoFeatureData} />
            </DesktopAndMobileDivWrapper>
          </>
        );
      case 'WEB_OFFER_SECTION_SLOT':
        return (
          offerData && (
            <LazyLoad
              height={100}
              once
              offset={100}
              key={element?.itemName + index}
            >
              <DesktopAndMobileDivWrapper>
                <PdpOfferNewDesign
                  offerList={offerData}
                  productId={productData?.id}
                  removeBottomMargin={true}
                  lactoMamaCategory={true}
                  eventHandler={eventHandler}
                />
                {sddNddData && (
                  <PdpNddSddStrip
                    sddNddData={sddNddData}
                    productData={productData}
                    userType={userType}
                  />
                )}
              </DesktopAndMobileDivWrapper>
            </LazyLoad>
          )
        );
      case 'BANNER_GIF':
        return (
          <div key={element?.itemName + index}>
            <LazyLoad height={100} once offset={100}>
              <DesktopAndMobileDivWrapper>
                {renderLactomamaDetail()}
              </DesktopAndMobileDivWrapper>
            </LazyLoad>
          </div>
        );
      case 'MARQUEE_STRIP':
        return (
          <DesktopAndMobileDivWrapper key={element?.itemName + index}>
            <MarqueeStrip
              lactoMama={true}
              tabThemeSecondaryColor={tabThemeSecondaryColor}
              tabThemeColor={tabThemeColor}
            />
          </DesktopAndMobileDivWrapper>
        );
      case 'TYPE_REELS':
        return (
          <LazyLoad
            height={100}
            once
            offset={100}
            key={element?.itemName + index}
          >
            <DesktopAndMobileDivWrapper>
              <VideoSection
                productId={productData?.id}
                data={element?.items}
                heading={element?.heading}
                sectionId={'lactomamaVideoSection'}
                generalItem={element}
                lactoMama={true}
                isFullScreenVideoEnabled={isFullScreenVideoEnabled}
                removeBottomMargin={true}
                setIsFullScreenVideoEnabled={setIsFullScreenVideoEnabled}
                showFullScreenVideo={showFullScreenVideo}
                setShowFullScreenVideo={setShowFullScreenVideo}
                setCurrentVideoIndex={setCurrentVideoIndex}
                tabThemeColor={tabThemeColor}
              />
            </DesktopAndMobileDivWrapper>
          </LazyLoad>
        );
      case 'VIDEO_GRID':
        return (
          <LazyLoad
            height={100}
            once
            offset={100}
            key={element?.itemName + index}
          >
            <DesktopAndMobileDivWrapper maxWidth={520}>
              <VideoGridSection data={element} />
            </DesktopAndMobileDivWrapper>
          </LazyLoad>
        );
      case 'MULTIPLE_ITEMS':
        if (element?.items?.[0]?.itemType === 'BANNER') {
          return index != 0 ? (
            <DesktopAndMobileDivWrapper maxWidth={520}>
              <TopCarousel
                banner={element}
                type={element?.viewType}
                lactoMamaCategory={true}
                key={element?.itemName + index}
                // innerCarousel={index != 0}
                forceMobileViewAssetsDownload={false}
                showSmallView={true}
              />
            </DesktopAndMobileDivWrapper>
          ) : (
            <TopCarousel
              banner={element}
              type={element?.viewType}
              lactoMamaCategory={true}
              key={element?.itemName + index}
              // innerCarousel={index != 0}
              forceMobileViewAssetsDownload={false}
            />
          );
        } else
          return (
            <LazyLoad
              height={100}
              once
              offset={100}
              key={element?.itemName + index}
            >
              <DesktopAndMobileDivWrapper>
                <ProductSection
                  selectDiaperRef={selectDiaperRef}
                  productData={element}
                  setChangeCartCount={setChangeCartCount}
                />
              </DesktopAndMobileDivWrapper>
            </LazyLoad>
          );

      case 'WEB_COUNTER_SLOT':
        return (
          <LazyLoad
            height={100}
            once
            offset={100}
            key={element?.itemName + index}
          >
            <DesktopAndMobileDivWrapper>
              <CDPageLiveCount
                pageLiveCountValue={pageLiveCountValue}
                changedIndexes={changedIndexes}
                description={'are regularly using Lactomama™'}
                happyTuesday={false}
                heading={'Raising Happiness of '}
                subHead={'Breastfeeding Moms'}
                textColor="#fff"
                textBackground={tabThemeColor}
                lactoMama={true}
                tabThemeColor={tabThemeColor}
              />
            </DesktopAndMobileDivWrapper>
          </LazyLoad>
        );
      case 'BANNER': {
        return (
          <LazyLoad
            height={100}
            once
            offset={100}
            key={element?.itemName + index}
          >
            <DesktopAndMobileDivWrapper>
              <SingleBanner
                data={element}
                key={element?.itemName}
                index={index}
                forceMobileViewAssetsDownload={false}
                lactoMama={true}
              />
            </DesktopAndMobileDivWrapper>
          </LazyLoad>
        );
      }
    }
  };

  useEffect(() => {
    if (!getUserIsLoggedIn() && showHeader == '0px') {
      const showKwikPassSsoTooltip = checkEligibilityForSsoTooltip();
      setShowSsoTooltip(showKwikPassSsoTooltip);
    } else {
      setShowSsoTooltip(false);
    }
  }, [getUserIsLoggedIn(), showHeader]);

  useEffect(() => {
    if (
      getUserIsLoggedIn() ||
      !checkEligibilityForSsoTooltip() ||
      showHeader != '0px'
    ) {
      setShowSsoTooltip(false);
      return;
    }
    let lastScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        if (showSsoTooltip) {
          setShowSsoTooltipDot(true);
        }
        setShowSsoTooltip(false);
      } else if (currentScrollY < lastScrollY || currentScrollY <= 50) {
        setShowSsoTooltip(true);
        setShowSsoTooltipDot(false);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [showSsoTooltip]);

  const openLoginPopUp = () => {
    setLoginPopUp(true);
  };

  return (
    <div>
      <PDPHeadElements
        productData={productData}
        ReviewJSONLDData={ReviewJSONLDData}
        DiscussionJSONLDData={DiscussionJSONLDData}
        userType={userType}
        breadCrumbsData={productData?.breadcrumb}
        fromOriginalPdp={true}
        offerData={offerData}
      />
      <CategoryHeadElement
        categoryId={DEFAULT_PRODUCT_ID}
        categoryData={{
          tabName: 'Boost Breast Milk Supply',
          icon: 'https://images.myloapp.in/NestJsUploads/1730704821042-Slide_1_P02_-(1).webp',
          webUrl:
            '/category/Increase-Breast-Milk-Supply-with-LactoMama-Lactation-Granules',
        }}
      />
      <GlobalStyle />

      <NewHeader
        showOldSubHeader={true}
        categoryData={categoryData}
        addedToCart={changeCartCount}
        showCart={true}
        showTrackOrder={true}
        setAddedToCart={setChangeCartCount}
        showHeader={showHeader}
        categoryNavBarTop={categoryNavBarTop}
        location={'cdPage'}
        pageLocation={'B2G1'}
        nostrip={true}
        setIsCartOpen={setIsCartOpen}
        showSsoTooltipDot={showSsoTooltipDot}
        loginPopUp={loginPopUp}
        setLoginPopUp={setLoginPopUp}
      />
      {/* <OfferStripHeader
                showHeader={showHeader}
                pdp={true}
                sticky={true}
                offerData={offerData}
            /> */}
      <KwikPassSsoTooltip
        setShowSsoTooltip={setShowSsoTooltip}
        fromCategory={true}
        showSsoTooltip={showSsoTooltip}
        openLoginPopUp={openLoginPopUp}
      />
      <DiaperWrapper catHideHeader={showHeader == '-56px'}>
        {generalItemsData?.items?.map((element, index) => {
          return renderGeneralItem(element, index);
        })}
        <DesktopAndMobileDivWrapper>
          <AccordionHeading lactoMama={true}>FAQs</AccordionHeading>
          <UniversalAccordion categoryAccordionData={FAQLactomama} faq={true} />
          <WhatsappBanner data={whatsappBanerData} lactoMamaCategory={true} />
          {/* Reviews Section Wrapper */}
          <div id="rating-reviews-section">
            <RatingReviews
              productData={productData}
              lactoMamaCategory={true}
              showNewReviewView={true}
            />
          </div>
          {floatingVideoData?.items?.length && isVideoVisible && (
            <FloatingVideo
              multipleVideos={floatingVideoData.items}
              isForLactoPage={true}
              setIsFullScreenVideoEnabled={setIsFullScreenVideoEnabled}
              isCartOpen={isCartOpen}
              currentVideoIndex={currentVideoIndex}
              showFullScreenVideo={showFullScreenVideo}
              setShowFullScreenVideo={setShowFullScreenVideo}
              setCurrentVideoIndex={setCurrentVideoIndex}
            />
          )}
        </DesktopAndMobileDivWrapper>
      </DiaperWrapper>
      <Modal
        isOpen={openPackPopup}
        onRequestClose={handleClose}
        style={BottomStylePopup}
        preventScroll={true}
        bodyOpenClassName="noScroll"
        htmlOpenClassName="noScroll"
        closeTimeoutMS={500}
        className={{
          base: 'bottomSheetPack',
          afterOpen: 'bottomSheetPackOpen',
          beforeClose: 'bottomSheetProductClose',
        }}
      >
        <ModalCrossbtn
          onClick={handleClose}
          src={images.CrossWhite}
          alt="Lacto Mama Select Popup close"
        />
        <PackBottomPopup
          variantData={variantDataForPopup}
          addToCart={addToCart}
          variantPriceData={productData?.variantData}
          productData={productData}
          productPriceData={productPriceData}
          userType={userType}
          handleClose={handleClose}
          isVariantPopup={true}
          // offerListFetcher={offerListFetcher}
        />
      </Modal>
      <NewFooter />
      <SnackBar className={showToast ? 'show' : ''}>{toastValue}</SnackBar>
      {showLoader && <Loader />}
    </div>
  );
}

export default LactoMamaPageOuter;
